module.exports = __webpack_public_path__ + "img/aisla-forte.efa9ff9b.png";